import React from 'react';
import { TextField} from '@mui/material';
import { BaseMUIComponentProps, ErrorStatus } from '../types/Types';

export interface  TextInputProps extends  BaseMUIComponentProps{
  initialInput?: string | number;
  handleInputChange: (value: string) => void;
  multiline?: boolean;
  label: string;
  name: string;
  placeholder?: string;
  errors?: ErrorStatus;
};

/**
 * TextInput
 *
 * A controlled text input component based on MUI's `TextField`.
 *
 * @param initialInput - The default value of the text input.
 * @param handleInputChange - on every value change.
 * @param multiline - Enables multi-line input mode if true.
 * @param label - displayed above the text input field.
 * @param name - The name attribute of the input.
 * @param placeholder - displayed inside the input when empty.
 * @param errors - Error status object used to display validation messages after form submission.
 */

export function TextInput({
  multiline,
  handleInputChange,
  placeholder,
  initialInput: defaultValue,
  name,
  errors,
  ...props
}: TextInputProps) {
  return (
    <TextField
      id="outlined-controlled"
      label={props.label}
      onChange={(e) => handleInputChange(e.target.value)}
      type="text"
      required={props.required}
      fullWidth
      variant="outlined"
      error={errors?.tag === 'Submited' && errors.errors?.length > 0}
      helperText={errors?.tag === 'Submited' ? errors.errors?.join(', ') : ''}
      defaultValue={defaultValue}
      name={name}
      multiline={multiline}
    />
  );
}